import React from "react";
import { Link } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import "./productcard.scss";

const ProductCards = ({ id, title, image, rating, price }) => {
  const [basket, dispatch] = useStateValue();
  console.log("basket content", basket);
  const addtoBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
      },
    });
  };

  const productDetails = () => {
    dispatch({
      type: "PRODUCT_DETAILS",
      item: {
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
       
      },
    });
  };

  return (

    <div className="card"  >
       <Link style={{textDecoration:"none"}} to="/productdetails" onClick={productDetails}>
      <i class="fas fa-share-alt"></i>
      <img src={image} className="card-img-top" alt={title} />
      <i className="far fa-heart"></i>
      </Link>
      {/* <i class="fas fa-plus" onClick={}></i> */}
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        
        <p className="d-flex card__rating">
          {Array(rating)
            .fill()
            .map((_) => (
              <img src="https://img.icons8.com/material-outlined/16/000000/star--v3.png" alt=""/>
            ))}
        </p>
          
        <p className="card-text">$ {price}/kg</p>
        <button type="button" className="addtocart__btn" onClick={addtoBasket}>
          Add to cart
        </button>
        
      </div>
    </div>
    
    
  );
};

export default ProductCards;
